module.exports = __webpack_public_path__ + "static/media/buch-rindchen-kocht.a8716303.png";